import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

export function CreateVersionAction({
  hasDraft,
  isCreatingDraft,
  onCreateDraft,
}: {
  hasDraft: boolean
  isCreatingDraft: boolean
  onCreateDraft: () => void
}) {
  return (
    <div className="gw-version-bar__create-wrap">
      <button
          type="button"
          onClick={() => !hasDraft && !isCreatingDraft && onCreateDraft()}
          disabled={hasDraft || isCreatingDraft}
          className={`gw-version-bar__create-btn ${
            hasDraft || isCreatingDraft ? 'gw-version-bar__create-btn--disabled' : ''
          }`}
        >
          <FontAwesomeIcon icon={faPlus} />
          {isCreatingDraft ? 'Creating…' : 'Create New Version'}
        </button>
        {hasDraft ? (
          <div className="gw-version-bar__tooltip">
            A draft version already exists. Edit or delete it first.
          </div>
        ) : null}
    </div>
  )
}
